import React, { useEffect, useRef, useState } from "react";
import styles from "./Gallery.module.css";
import g1 from "../../../../assets/staticImages/gallery/g1.png";
import g2 from "../../../../assets/staticImages/gallery/g2.png";
import g3 from "../../../../assets/staticImages/gallery/g3.png";
import g4 from "../../../../assets/staticImages/gallery/g4.png";
import g5 from "../../../../assets/staticImages/gallery/g5.png";
import g6 from "../../../../assets/staticImages/gallery/g6.png";
import g7 from "../../../../assets/staticImages/gallery/g7.png";
import SearchInput from "../../../../components/searchInput/SearchInput";
import SubmitButton from "../../../../components/submitButton/SubmitButton";
import { DropDown, InputField, TextComponent } from "../../../../components";
import { Col, List, Radio, Row } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { BoxTabs } from "../../../../components/AntdTab/AntdTab";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";
import { PhotosMiddleware } from "../../../../Store/Middlewares/PhotosMiddleware";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Modal from "../../../../components/modal/Modal";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import dummyImg from "../../../../assets/imageplace.jpg";
import { InspirationalGalleryMiddleware } from "../../../../Store/Middlewares/InspirationalGalleryMiddleware";

const MyPhotos = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const role = Storage.getERole("@role");
  const { state } = useLocation();
  const event_id = state?.eventData?.id;
  const MyPhotosList = useSelector((state) => state.PhotosReducer.MyPhotosList);
  const MyPhotosListPagination = useSelector(
    (state) => state.PhotosReducer.MyPhotosListPagination
  );
  const [search, setSearch] = useState();
  const [categoryModal, setCategoryModal] = useState(false);
  const [value, setValue] = useState(1);
  const [categoryId, setCategoryId] = useState(false);
  const [newCategoryName, setnewCategoryName] = useState(null);
  const [loader, setloader] = useState(true);

  // const EventCategory = useSelector(
  //   (state) => state.EventReducer.EventDetails?.inspiration_gallery_categories
  // );
  const galleryCategory = useSelector(
    (state) => state.PhotosReducer.eventGalleryCategories
  );
  const timeout = useRef();
  // console.log("galleryCategory=->>>>>>>", galleryCategory);
  // console.log("state", state);
  useEffect(() => {
    getData();
    getGalleryCategory();
  }, []);

  const getData = () => {
    let data = {
      event_id: event_id,
      search: undefined,
      next_page_url: undefined,
    };
    dispatch(PhotosMiddleware.getMyPhotos(data));
  };
  // console.log("MyPhotosList", MyPhotosList);
  const getGalleryCategory = () => {
    let data = {
      event_id: event_id,
    };
    dispatch(PhotosMiddleware.getEventGalleryCategories(data));
  };
  const onCreateNewCategory = () => {
    if (!newCategoryName) {
      dispatch(
        showAlert({
          type: "Warning",
          message: "Please Enter Category",
        })
      );
    } else if (
      galleryCategory.find(
        (e) => e.name.toLowerCase() == newCategoryName.toLowerCase()
      )
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: `${newCategoryName} already exist`,
        })
      );
    } else {
      setCategoryModal(false);
      dispatch(
        PhotosMiddleware.createEventGalleryCategory({
          event_id,
          name: newCategoryName,
        })
      )
        .then(
          (data) =>
            navigation("/events/uploadGallery", {
              state: {
                event_id: event_id,
                category: { category_id: data.id, category_name: data.name },
              },
            }),
          setnewCategoryName(null)
        )
        .catch((err) => console.log("err", err));
    }
  };

  const onNext = () => {
    if (!categoryId) {
      dispatch(
        showAlert({
          type: "Warning",
          message: "Please Select Category",
        })
      );
    } else {
      navigation("/events/uploadGallery", {
        state: {
          event_id: event_id,
          category: {
            category_id: categoryId.id,
            category_name: categoryId.val,
          },
        },
      });
      setnewCategoryName(null);
    }
  };
  const onPressRenderMoreContent = () => {
    let data = {
      event_id: event_id,
      search: search,
      next_page_url: MyPhotosListPagination?.links?.next,
    };
    dispatch(PhotosMiddleware.getMyPhotos(data));
  };
  // const onSearch = (e) => {

  //   let data = {
  //     event_id: event_id,
  //     search: e,
  //     next_page_url: undefined,
  //   };
  //   setSearch(e);
  //   clearTimeout(timeout.current);
  //   timeout.current = setTimeout(() => {

  //     dispatch(PhotosMiddleware.getMyPhotos(data))

  //   }, 1500);
  // };
  const onSearchEachImage = (e) => {
    let data = {
      event_id: event_id,
      search: e,
      next_page_url: undefined,
    };
    setSearch(e);
    setloader(true);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      dispatch(PhotosMiddleware.getMyPhotos(data))
        .then(() => {
          setloader(false);
        })
        .catch(() => setloader(false));
    }, 1500);
  };
  const onChange = (e) => {
    setValue(e.target.value);
  };

  const renderMyImages = (item, index) => {
    if (item?.type == "video") {
      return (
        <div
          key={index}
          className={styles.listItem}
          onClick={() =>
            navigation("/events/singleImage", {
              state: {
                headrTitle: "Gallery",
                item: item,
                screenType: "myPhoto",
              },
            })
          }
        >
          <div className={styles.square}>
            <video className={styles.video} controls>
              <source src={item?.files} />
            </video>
          </div>
        </div>
      );
    } else {
      return (
        <div
          key={index}
          className={styles.listItem}
          onClick={() =>
            navigation("/events/singleImage", {
              state: {
                headrTitle: "Gallery",
                item: item,
                screenType: "myPhoto",
              },
            })
          }
        >
          <div className={styles.square}>
            <img
              src={item?.image ? item?.image : dummyImg}
              className={styles.listImg}
            />
            <div className={styles.ItemName}>
              <TextComponent text={item?.name} textClass={styles.nameTxt} />
            </div>
          </div>
        </div>
      );
    }
  };
  return (
    <div className={styles.mainCon}>
      <Row className={styles.head} gutter={12}>
        <Col xs={24} sm={16} lg={18} className={styles.headLeft}>
          <SearchInput
            placeholder={"Search"}
            value={search}
            onChange={(e) => onSearchEachImage(e.target.value)}
          />
        </Col>
        <Col xs={24} sm={8} lg={6} className={styles.headRight}>
          {/* <SubmitButton
            title={"Upload Photo"}
            onClick={() => navigation("/events/uploadGallery",{
              state: event_id
            })}
          /> */}
          <SubmitButton
            title={"Category"}
            btnClass={styles.btn}
            onClick={() => setCategoryModal(true)}
          />
        </Col>
      </Row>
      <div className={styles.txtDiv}>
        <TextComponent
          text={
            "Collect and save event photos from your guests to enjoy for a lifetime. Because it only happens once!"
            // role === roles.guest
            //   ? "Upload wedding photos of your Event to enjoy for a lifetime. Because it only happens once!"
            //   : "Collect and save wedding photos from your guests to enjoy for a lifetime. Because it only happens once!"
          }
          textClass={styles.Txt}
        />
      </div>
      <TextComponent
        text={
          state?.eventData?.name ? state?.eventData?.name : "--"
          // role === roles.guest
          //   ? "James and Lucy Marriage"
          //   : "Engagement Ceremony"
        }
        textClass={styles.headingTxt}
      />
      <List
        className={styles.list}
        grid={{ gutter: 16 }}
        itemLayout="horizontal"
        dataSource={MyPhotosList}
        renderItem={renderMyImages}
        footer={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {MyPhotosListPagination?.links?.next != null ? (
              <div style={{ width: "50%" }}>
                <SubmitButton
                  title={"Load More"}
                  onClick={onPressRenderMoreContent}
                />
              </div>
            ) : null}
          </div>
        }
      />
      {categoryModal && (
        <Modal
          isModalOpen={categoryModal}
          setIsModalOpen={setCategoryModal}
          closable={true}
          className={styles.modal}
        >
          <div className={styles.modalCon}>
            <div className={styles.modalConLeft}>
              <svg
                viewBox="0 0 375 376"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M156.689 47.499H63.1888C59.0558 47.499 55.0922 49.1452 52.1697 52.0755C49.2473 55.0057 47.6055 58.98 47.6055 63.124V156.874C47.6055 161.018 49.2473 164.992 52.1697 167.923C55.0922 170.853 59.0558 172.499 63.1888 172.499H156.689C160.822 172.499 164.785 170.853 167.708 167.923C170.63 164.992 172.272 161.018 172.272 156.874V63.124C172.272 58.98 170.63 55.0057 167.708 52.0755C164.785 49.1452 160.822 47.499 156.689 47.499ZM312.522 203.749H219.022C214.889 203.749 210.925 205.395 208.003 208.325C205.081 211.256 203.439 215.23 203.439 219.374V313.124C203.439 317.268 205.081 321.242 208.003 324.173C210.925 327.103 214.889 328.749 219.022 328.749H312.522C316.655 328.749 320.619 327.103 323.541 324.173C326.464 321.242 328.105 317.268 328.105 313.124V219.374C328.105 215.23 326.464 211.256 323.541 208.325C320.619 205.395 316.655 203.749 312.522 203.749ZM265.772 47.499C231.395 47.499 203.439 75.5303 203.439 109.999C203.439 144.468 231.395 172.499 265.772 172.499C300.149 172.499 328.105 144.468 328.105 109.999C328.105 75.5303 300.149 47.499 265.772 47.499ZM109.939 203.749C75.562 203.749 47.6055 231.78 47.6055 266.249C47.6055 300.718 75.562 328.749 109.939 328.749C144.316 328.749 172.272 300.718 172.272 266.249C172.272 231.78 144.316 203.749 109.939 203.749Z"
                  fill="var(--primary-color)"
                />
              </svg>
            </div>

            <div className={styles.modalConRight}>
              <TextComponent
                text={"Please Create Or Select Category"}
                textClass={styles.modalHeading}
              />
              <div>
                <Radio.Group onChange={onChange} value={value}>
                  <Radio value={1}>Create</Radio>
                  <Radio value={2}>Select</Radio>
                </Radio.Group>
              </div>
              {value == 1 ? (
                <InputField
                  label="Create Category"
                  placeholder={"category"}
                  value={newCategoryName}
                  onChange={(e) => setnewCategoryName(e.target.value)}
                />
              ) : (
                <DropDown
                  placeholder={"category"}
                  label="Select Category"
                  stylesClass={styles.dropdown}
                  name={"category"}
                  onChange={(values) => setCategoryId(values)}
                  object={galleryCategory}
                />
              )}
              <div className={styles.modalBtns}>
                <SubmitButton
                  onClick={() =>
                    value == 1 ? onCreateNewCategory() : onNext()
                  }
                  textClass={styles.modalBtnTxt}
                  title={value == 1 ? "Create" : "Next"}
                  btnClass={styles.modalBtn}
                />
                <SubmitButton
                  textClass={styles.modalBtnTxt}
                  outline={true}
                  title={"Cancel"}
                  btnClass={styles.modalBtn}
                  onClick={() => {
                    setCategoryModal(false);
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

const GuestPhotos = () => {
  const { state } = useLocation();
  const event_id = state?.eventData?.id;
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState();
  const timeout = useRef(null);
  const AllPhotos = useSelector((state) => state.PhotosReducer.AllPhotos);
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    let data = {
      event_id: event_id,
      search: undefined,
      next_page_url: undefined,
    };
    dispatch(PhotosMiddleware.getAllPhotos(data));
  };

  const onSearchEachImage = (e) => {
    let data = {
      event_id: event_id,
      search: e,
      next_page_url: undefined,
    };
    setSearch(e);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      dispatch(PhotosMiddleware.getAllPhotos(data));
    }, 1000);
  };
  const renderGuestImages = (item, index) => {
    // if (item?.attachments?.data?.[0]?.type == "video") {
    //   return (
    //     <div
    //       key={index}
    //       className={styles.listItem}
    //       onClick={() =>
    //         navigation("/events/WeddingHighlightDetails", {
    //           state: { ...state, headrTitle: "Gallery", item: item },
    //         })
    //       }
    //     >
    //       <div className={styles.square}>
    //         <video className={styles.video} controls>
    //           <source src={item?.attachments?.data?.[0]?.files} />
    //         </video>
    //         <div className={styles.ItemName}>
    //           <TextComponent
    //             text={"Uploaded By:"}
    //             textClass={styles.uploadTxt}
    //           />
    //           <TextComponent
    //             text={item?.user_name}
    //             textClass={styles.nameTxt}
    //           />
    //           {/* <div style={{display: 'flex', flexDirection: 'column'}}> */}
    //           <TextComponent text={item?.nop} textClass={styles.nopTxt} />
    //           <TextComponent
    //             text={moment(item?.attachments?.data?.created_at).format(
    //               "D MMM YYYY"
    //             )}
    //             textClass={styles.dateTxt}
    //           />
    //           {/* </div> */}
    //         </div>
    //       </div>
    //     </div>
    //   );
    // } else {
    return (
      <div
        key={index}
        className={styles.listItem}
        onClick={() =>
          navigation("/events/WeddingHighlightDetails", {
            state: { ...state, headrTitle: "Gallery", item: item },
          })
        }
      >
        <div className={styles.square}>
          {item?.attachments?.data?.[0]?.type == "video" ? (
            <img
              src={
                item?.attachments?.data?.[0]?.thumbnail
                  ? item?.attachments?.data?.[0]?.thumbnail
                  : dummyImg
              }
              className={styles.listImg}
            />
          ) : (
            <img
              src={
                item?.attachments?.data?.[0]?.files
                  ? item?.attachments?.data?.[0]?.files
                  : dummyImg
              }
              className={styles.listImg}
            />
          )}
          <div className={styles.ItemName}>
            <TextComponent text={"Uploaded By:"} textClass={styles.uploadTxt} />
            <TextComponent text={item?.user_name} textClass={styles.nameTxt} />
            {/* <div style={{display: 'flex', flexDirection: 'column'}}> */}
            <TextComponent text={item?.nop} textClass={styles.nopTxt} />
            <TextComponent
              text={moment(item?.attachments?.data?.created_at).format(
                "D MMM YYYY"
              )}
              textClass={styles.dateTxt}
            />
            {/* </div> */}
          </div>
        </div>
      </div>
    );
    // }
    // console.log("iteeeeeeeeeemmmm", item)
  };
  return (
    <div className={styles.mainCon}>
      <Row className={styles.head}>
        <Col xs={24} className={styles.headLeft}>
          <SearchInput
            placeholder={"Search"}
            value={search}
            onChange={(e) => onSearchEachImage(e.target.value)}
          />
        </Col>
        {/* <div className={styles.headRight}>
          <SubmitButton
            title={"Upload Photo"}
            onClick={() => navigation("/events/uploadGallery")}
          />
        </div> */}
      </Row>
      <div className={styles.txtDiv}>
        <TextComponent
          text={
            "Collect and save event photos from your guests to enjoy for a lifetime. Because it only happens once!"
          }
          textClass={styles.Txt}
        />
      </div>
      <TextComponent
        text={state?.eventData?.name ? state?.eventData?.name : "--"}
        textClass={styles.headingTxt}
      />
      <List
        className={styles.list}
        grid={{ gutter: 16 }}
        itemLayout="horizontal"
        dataSource={AllPhotos}
        renderItem={renderGuestImages}
      />
    </div>
  );
};

const Gallery = () => {
  const items = [
    {
      key: "1",
      label: "My Photos",
      children: <MyPhotos />,
      // onClick: () => {
      //   navigate(".", { state: { headrTitle: "Event Detail" } });
      // },
    },
    {
      key: "2",
      label: "Wedding Highlights",
      children: <GuestPhotos />,
      // onClick: () => {
      //   navigate(".", { state: { headrTitle: "Planning Form" } });
      //   console.log("reload");
      // },
    },
  ];

  return (
    <BoxTabs
      items={items}
      // changeHeaderOnTab={true}
      // activeKey={state?.activeKey}
    />
  );
};

export default Gallery;
